import { useTranslations } from "next-intl";
import CheckIcon from "../_icons/checkIcon";
import DashInCircleIcon from "../_icons/DashInCircleIcon";
import ExclamationInCircleIcon from "../_icons/ExclaimationInCircleIcon";

interface BannerProps {
  count: number;
  message?: string;
}

export const SuccessBanner = ({ count, message }: BannerProps) => {
  const t = useTranslations("SuccessBanner");
  return (
    <div className="rounded-xl mx-4 bg-[#F2FCEE] border-[#276A16] border-[1px] p-4 flex items-center">
      <CheckIcon />
      <span className="ml-4">
        {message || t("itemsAddedToCart", { count })}
      </span>
    </div>
  );
};

export const UnavailableBanner = ({ count, message }: BannerProps) => {
  const t = useTranslations("UnavailableBanner");
  return (
    <div
      className={`rounded-xl mx-4 ${
        count > 0
          ? "bg-[#FFF6CC] border-[#FFD100]"
          : "bg-[#FFEDED] border-[#E70000]"
      } border-[1px] p-4 flex items-center`}
    >
      {count > 0 ? <DashInCircleIcon /> : <ExclamationInCircleIcon />}
      <span className="ml-4">
        {message ||
          (count > 0
            ? t("itemsUnavailable", { count })
            : t("allItemsUnavailable"))}
      </span>
    </div>
  );
};
